import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";

export default function SmartLink({ href, children, className, testId }) {
  if (!href) return null;
  if (href.startsWith("/")) {
    return (
      <Link data-testid={testId} to={href} className={className}>
        {children}
      </Link>
    );
  }
  return (
    <a data-testid={testId} href={href} target="_blank" rel="noreferrer" className={className}>
      {children} <ExternalLink size={11} className="inline" />
    </a>
  );
}
